import { KEY } from '../../types';
import * as types from './types';

export const GET_HEALTH_DOCUMENTS = `${KEY}.GET_HEALTH_DOCUMENTS`;
export const GET_HEALTH_DOCUMENTS_SUCCESS = `${KEY}.GET_HEALTH_DOCUMENTS_SUCCESS`;
export const GET_HEALTH_DOCUMENTS_FAIL = `${KEY}.GET_HEALTH_DOCUMENTS_FAIL`;

export const getHealthDocuments = () => ({
  type: GET_HEALTH_DOCUMENTS,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'getHealthDocuments'
    }
  }
});

export const SEARCH_HEALTH_DOCUMENTS = `${KEY}.SEARCH_HEALTH_DOCUMENTS`;
export const SEARCH_HEALTH_DOCUMENTS_SUCCESS = `${KEY}.SEARCH_HEALTH_DOCUMENTS_SUCCESS`;
export const SEARCH_HEALTH_DOCUMENTS_FAIL = `${KEY}.SEARCH_HEALTH_DOCUMENTS_FAIL`;

export const searchHealthDocuments = () => ({
  type: SEARCH_HEALTH_DOCUMENTS,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'searchHealthDocuments'
    }
  }
});

// ⬇ File add for web ⬇ //
export const ADD_HEALTH_DOCUMENT = `${KEY}.ADD_HEALTH_DOCUMENT`;
export const ADD_HEALTH_DOCUMENT_SUCCESS = `${KEY}.ADD_HEALTH_DOCUMENT_SUCCESS`;
export const ADD_HEALTH_DOCUMENT_FAIL = `${KEY}.ADD_HEALTH_DOCUMENT_FAIL`;

export const addHealthDocument = (payload: types.AddHealthDocumentPayload) => ({
  type: ADD_HEALTH_DOCUMENT,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'addHealthDocument',
      data: payload
    }
  }
});

// ⬇ Image add for mobile ⬇ //
export const UPLOAD_CONSUMER_IMAGE = `${KEY}.UPLOAD_CONSUMER_IMAGE`;
export const UPLOAD_CONSUMER_IMAGE_SUCCESS = `${KEY}.UPLOAD_CONSUMER_IMAGE_SUCCESS`;
export const UPLOAD_CONSUMER_IMAGE_FAIL = `${KEY}.UPLOAD_CONSUMER_IMAGE_FAIL`;

export const uploadConsumerImage = (payload: types.UploadConsumerImage) => ({
  type: UPLOAD_CONSUMER_IMAGE,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'uploadConsumerImage',
      data: payload
    }
  }
});

export const REMOVE_HEALTH_DOCUMENT = `${KEY}.REMOVE_HEALTH_DOCUMENT`;
export const REMOVE_HEALTH_DOCUMENT_SUCCESS = `${KEY}.REMOVE_HEALTH_DOCUMENT_SUCCESS`;
export const REMOVE_HEALTH_DOCUMENT_FAIL = `${KEY}.REMOVE_HEALTH_DOCUMENT_FAIL`;

export const removeHealthDocument = (payload: types.RemoveHealthDocumentPayload) => ({
  type: REMOVE_HEALTH_DOCUMENT,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'removeHealthDocument',
      data: payload
    }
  }
});
